import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalCellularNullIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_cellular_null"}/>
}
